import type { ParticipantFieldGroup } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { useWatch } from 'react-hook-form';
import { FormErrorsBadge } from '../../components/generic/FormErrorsBadge';
import { ParticipantFormFieldGroup } from './ParticipantFormFieldGroup';
import { ParticipantFormGeneral } from './ParticipantFormGeneral';
import { ParticipantFormKeyContacts } from './ParticipantFormKeyContacts';

interface Props {
  isDisabled?: boolean;
  openToTabValue?: string;
}

export const ParticipantForm = (props: Props) => {
  const { isDisabled, openToTabValue } = props;

  const fieldGroups = (useWatch({ name: 'fieldGroups' }) as ParticipantFieldGroup[]) ?? [];

  return (
    <ChakraV3.Tabs.Root
      defaultValue={openToTabValue ?? 'general'}
      variant='subtle'
      orientation='vertical'
      size='sm'
      lazyMount
      unmountOnExit
      h='full'
    >
      <ChakraV3.Tabs.List>
        <ChakraV3.Tabs.Trigger value='general'>
          General
          <FormErrorsBadge
            names={[
              'firstName',
              'lastName',
              'dob',
              'gender',
              'status',
              'locationId',
              'picture',
              'address',
              'suburb',
              'state',
              'postcode',
            ]}
          />
        </ChakraV3.Tabs.Trigger>
        <ChakraV3.Tabs.Trigger value='keyContacts'>
          Key contacts
          <FormErrorsBadge names={['keyContacts']} />
        </ChakraV3.Tabs.Trigger>
        {fieldGroups.map((fieldGroup) => (
          <ChakraV3.Tabs.Trigger
            value={`${fieldGroup.template.name}-${fieldGroup.template.index}`}
            key={`${fieldGroup.id}`}
          >
            {fieldGroup.template.name}
          </ChakraV3.Tabs.Trigger>
        ))}
      </ChakraV3.Tabs.List>
      <ChakraV3.Tabs.ContentGroup
        h='full'
        w='full'
        ml={6}
        pl={3}
        borderLeftWidth='1px'
        borderLeftColor='gray.200'
      >
        <ChakraV3.Tabs.Content value='general'>
          <ParticipantFormGeneral isDisabled={isDisabled} />
        </ChakraV3.Tabs.Content>
        <ChakraV3.Tabs.Content value='keyContacts'>
          <ParticipantFormKeyContacts isDisabled={isDisabled} />
        </ChakraV3.Tabs.Content>
        {fieldGroups.map((fieldGroup, fieldGroupIndex) => (
          <ParticipantFormFieldGroup
            key={`${fieldGroup.id}-panel`}
            fieldGroup={fieldGroup}
            fieldGroupIndex={fieldGroupIndex}
            isDisabled={isDisabled}
          />
        ))}
      </ChakraV3.Tabs.ContentGroup>
    </ChakraV3.Tabs.Root>
  );
};
